export enum DashboardTabsEnum {
  DRP = 'DRP',
  WNI = 'WNI',
  OCC = 'OCC',
}
